import React, { useState } from "react";
import {
  Button,
  Iconography,
  IconographySizes,
} from "@hid-galaxy-ui/galaxy-react";
import "./EditEventModal.scss";
import { getFileUrl } from "../../../../../redux/saga/partner-program/calculator/saga-action";
import { useAppDispatch } from "../../../../../redux";



interface EditEventModalProps {
  isOpen: boolean;
  onClose: () => void;
  eventData: {
    ID: any;
    label: string;
    event_date: string;
    event_time: string;
    event_title: string;
    event_type: string;
    comments: string;
    documents: any;
  };
  onSave: (data: any) => void;
}

const EditEventModal: React.FC<EditEventModalProps> = ({
  isOpen,
  onClose,
  eventData,
  onSave,
}) => {
    const dispatch = useAppDispatch();
  // Convert date format from "Dec 15, 2024" to "2024-12-15"
  const convertToInputDate = (dateStr: string) => {
    const date = new Date(dateStr);
    if (isNaN(date.getTime())) return "";
    return date.toISOString().split("T")[0];
  };

  // Convert time format from "10:00 AM" to "10:00" (24-hour)
  const convertToInputTime = (timeStr: string) => {
    if (!timeStr) return "";
      console.log("hours, minutes",timeStr)
    const [time, period] = timeStr.split(" ");
    let [hours, minutes] = time.split(":").map(Number);
    console.log("hours, minutes",hours, minutes,period,time,timeStr)
    if (period === "PM" && hours !== 12) hours += 12;
    if (period === "AM" && hours === 12) hours = 0;
    return `${hours.toString().padStart(2, "0")}:${minutes
      .toString()
      .padStart(2, "0")}`;
  };

  const [formData, setFormData] = useState({
    event_type: eventData.event_type,
    event_title: eventData.event_title,
    // event_date: convertToInputDate(eventData.event_date),
    event_time: eventData.event_time ? convertToInputTime(eventData.event_time) : '',
     event_date: (eventData.event_date),
    //event_time: (eventData.event_time),
    comments: eventData.comments,
    documents: eventData.documents,
    ID:eventData.ID
  });

  const [newDocuments, setNewDocuments] = useState([]);

  const handleInputChange = (field: string, value: string) => {
    setFormData((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  const handleFileUpload = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (event.target.files) {
      console.log("event.target.files=>",event.target.files)
      const files = Array.from(event.target.files);
      setNewDocuments((prev:any) => [...prev, ...files]);
    }
  };

  const handleRemoveDocument = (index: number) => {
    setNewDocuments((prev:any) => prev.filter((_: any, i: number) => i !== index));
  };

    const handleRemoveOldDocument = (index: number) => {;
      let formDataValue=structuredClone(formData);
      formDataValue.documents.splice(index,1);
      setFormData({...formDataValue})
    //setNewDocuments((prev:any) => prev.filter((_: any, i: number) => i !== index));
  };

  

  const handleUpdate = () => {
    //console.log("newDocuments",newDocuments)

    //console.log("newadd",[...newDocuments,...formData.documents])
    onSave({...formData,
      documents:formData.documents && formData.documents.length ?  [...newDocuments,...formData.documents] : newDocuments
    });
    onClose();
  };

  const handleCancel = () => {
    onClose();
  };

  const downloadFileUrlFn=(fileName:any,fileType:any)=>{

    dispatch(getFileUrl(fileName,fileType));

  }

  // Check if both event_date and event_time are filled
  const isFormValid = formData.event_date && formData.event_time;

  if (!isOpen) return null;

  return (
    <div className="edit-event-modal-overlay">
      <div className="edit-event-modal">
        <div className="modal-header">
          <h2>Edit Event</h2>
          <button className="close-button" onClick={onClose}>
            <Iconography icon="xmark" size={IconographySizes.Medium} />
          </button>
        </div>

        <div className="modal-body">
          <div className="form-group">
            <label>Event Type</label>
            <input
              type="text"
              className="form-input"
              placeholder="Enter event type"
              value={formData.event_type}
              disabled
              onChange={(e) => handleInputChange("event_type", e.target.value)}
            />
          </div>

          <div className="form-group">
            <label>Event Title</label>
            <input
              type="text"
              className="form-input"
              placeholder="Enter event title"
              value={formData.event_title}
              disabled
              onChange={(e) => handleInputChange("event_title", e.target.value)}
            />
          </div>

          <div className="form-row">
            <div className="form-group">
              <label>Event Date</label>
              <input
                type="date"
                className="form-input"
                value={formData.event_date}
                onChange={(e) => handleInputChange("event_date", e.target.value)}
              />
            </div>

            <div className="form-group">
              <label>Event Time</label>
              <input
                type="time"
                className="form-input"
                value={formData.event_time}
                onChange={(e) => handleInputChange("event_time", e.target.value)}
              />
            </div>
          </div>

          <div className="form-group">
            <label>
              Comment (Optional)
              {/* <span className="char-count">{formData.comment.length}/500</span> */}
            </label>
            <textarea
              className="form-textarea"
              placeholder="Comment"
              value={formData.comments}
              onChange={(e) => handleInputChange("comments", e.target.value)}
              maxLength={500}
              rows={5}
            />
          </div>

          <div className="form-group">
            <div className="file-upload-section">
              <label htmlFor="file-upload" className="file-upload-button">
                ADD FILES
              </label>
              <input
                id="file-upload"
                type="file"
                multiple
                onChange={handleFileUpload}
                style={{ display: "none" }}
              />
            </div>

            {formData.documents && formData.documents.length ?
              <div className="uploaded-files">
                {formData.documents.map((file:any, index:number) => (
                  <div key={index} className="uploaded-file-item">
                    <a 
                          //target="_blank"
                          onClick={()=>{
                            downloadFileUrlFn(file,'view')
                          }}
                           key={index} 
                           //href={doc} 
                           className="document-item">
                            <span className="document-link">{file}</span>
                            </a>
                    {/* <span>{file}</span> */}
                    <button
                      className="remove-file-button"
                      onClick={() => handleRemoveOldDocument(index)}
                    >
                      <Iconography icon="xmark" size={IconographySizes.Small} />
                    </button>
                  </div>
                ))}
              </div> : ''
            }

            {newDocuments.length > 0 && (
              <div className="uploaded-files">
                {newDocuments.map((file:any, index:number) => (
                  <div key={index} className="uploaded-file-item">
                    <span>{file.name}</span>
                    <button
                      className="remove-file-button"
                      onClick={() => handleRemoveDocument(index)}
                    >
                      <Iconography icon="xmark" size={IconographySizes.Small} />
                    </button>
                  </div>
                ))}
              </div>
            )}
          </div>
        </div>

        <div className="modal-footer">
          <Button variant="secondary" label="CANCEL" onClick={handleCancel} />
          <Button variant="primary" label="UPDATE" onClick={handleUpdate} disabled={!isFormValid} />
        </div>
      </div>
    </div>
  );
};

export default EditEventModal;
